<div class="page-container" [class.loading]="isLoading">
    <!-- Loading overlay -->
    <div class="loading-overlay" *ngIf="isLoading">
        <div class="loading-spinner">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <p class="mt-3">Processing your request...</p>
        </div>
    </div>

    <h2 class="form-title">Re-Emit Event</h2>
    <div class="event-emitter-container">
        <div class="ticker-container">
            <div class="ticker-text">
                <span style="font-style: italic;">
                    You can only emit events to the <strong>test region</strong>. For any other region, please check with the Dev Team.
                </span>
            </div>
        </div>
        <div class="form-row">
            <div class="col">
                <label for="eventCount">Number of events to be emitted</label>
                <input type="number" id="eventCount" [(ngModel)]="eventCount" name="eventCount" class="form-control" [disabled]="isLoading" required />
                <div class="mt-2">
                    <label for="executionPassword">Password for Execution</label>
                    <input type="password" id="executionPassword" [(ngModel)]="executionPassword" name="executionPassword" class="form-control" [disabled]="isLoading" required />
                </div>
            </div>
            <div class="col">
                <label for="eventName">Event name</label>
                <select id="eventName" name="eventName" class="form-control" [(ngModel)]="eventName" [disabled]="isLoading" required>
                    <option value="" disabled selected>Select event name</option>
                    <option value="complete-episerver-design">complete-episerver-design</option>
                    <option value="create-design-file">create-design-file</option>
                    <option value="create-design-file-result">create-design-file-result</option>
                    <option value="custom-genie-order">custom-genie-order</option>
                    <option value="design-file-sync">design-file-sync</option>
                    <option value="design-update">design-update</option>
                    <option value="episerver-csg-order">episerver-csg-order</option>
                    <option value="episerver-design-request">episerver-design-request</option>
                    <option value="episerver-nis-order">episerver-nis-order</option>
                    <option value="episerver-order">episerver-order</option>
                    <option value="import-design">import-design</option>
                    <option value="nav-customer-change">nav-customer-change</option>
                    <option value="nav-invoice-change">nav-invoice-change</option>
                    <option value="new-design-image">new-design-image</option>
                    <option value="new-fastpens-order">new-fastpens-order</option>
                    <option value="new-nbi-order">new-nbi-order</option>
                    <option value="new-sales-order">new-sales-order</option>
                    <option value="new-sales-order-exception">new-sales-order-exception</option>
                    <option value="new-stickers-order">new-stickers-order</option>
                    <option value="order-cancelled">order-cancelled</option>
                    <option value="order-checkpoint-changed">order-checkpoint-changed</option>
                    <option value="order-created-in-nav">order-created-in-nav</option>
                    <option value="order-imported">order-imported</option>
                    <option value="order-posted">order-posted</option>
                    <option value="order-produced">order-produced</option>
                    <option value="order-redirected">order-redirected</option>
                    <option value="order-shipped">order-shipped</option>
                    <option value="order-tracked">order-tracked</option>
                    <option value="packingslip-printed">packingslip-printed</option>
                    <option value="print-orders">print-orders</option>
                    <option value="print-work-order">print-work-order</option>
                    <option value="release-batch">release-batch</option>
                    <option value="release-episerver-csg-order">release-episerver-csg-order</option>
                    <option value="release-episerver-design-request">release-episerver-design-request</option>
                    <option value="sales-order-update">sales-order-update</option>
                    <option value="update-checkpoint">update-checkpoint</option>
                </select>
            </div>
        </div>
        <div class="form-row mt-3">
            <div class="col">
                <button type="submit" class="btn btn-primary" [disabled]="isLoading" (click)="onSubmit()">
                    <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
                    {{ isLoading ? 'Processing...' : 'Submit' }}
                </button>
            </div>
        </div>
        <div class="ticker-container">
            <div class="ticker-text">
                <span style="font-style: italic;">
                    If you dont have the password, please contact the Dev Team.
                </span>
            </div>
        </div>
    </div>
</div>
